module.exports = __webpack_public_path__ + "static/media/caution.3c132ffe.svg";